// 渠道任务
export interface ChannelTask {
  task_id: number; // 任务ID
  task_type_id: number; // 任务类型ID
  task_type_name: string; // 任务类型名称
  title: string; // 任务标题
  todo_user_list: string[]; // 待处理人列表
  total_time: number; // 总学习时长
  update_comment: string; // 修改备注
  begin_date: string; // 开始时间
  end_date: string; // 结束时间
  collect_task_status: 0 | 1; // 任务收藏状态（0：未收藏 1：收藏）
  content: string; // 任务详情
  core_task_process_info: TaskProgressInfo;
  course_info_list: ChannelTaskCourseInfo[]; // 课程列表
  deal_url: string; // 【去处理】跳转地址
  is_system_monitor: boolean; // 是否系统监控指标
  last_operate_time: string; // 最后处理时间
  last_operator: string; // 处理人
  learned_time: number; // 已学习时长
  show_deal: boolean; // 是否可操作【去处理】
  status: ChannelTaskStatusText; // 任务状态
  status_value: ChannelTaskStatus; // 任务状态值
  support_deal: boolean; // 是否可操作【去处理】
  support_ignore: SupportUpdateTaskStatusConfig; // 忽略
  support_mark_finished: SupportUpdateTaskStatusConfig; // 是否允许标记已完成
}


export enum ChannelTaskStatus {
  unfinished = 0, // 未处理"
  finished = 1, // 已完成"
  mark_finished = 2, // 标记完成
  ignored = 3, // 已忽略
  expired = 4, // 过期
  not_started = 5, // 未开始
}

export enum ChannelTaskStatusText {
  unfinished = '未处理',
  finished = '已完成',
  mark_finished = '标记完成',
  ignored = '已忽略',
  expired = '过期',
  not_started = '未开始',
}

// 系统监控指标
export enum ChannelTaskMonitorTarget {
  advertisement = 1, // 广告数
  recharge_times = 2, // 充值次数
  recharge_amount = 3, // 充值金额
  cost_amount = 4, // 消耗金额
}

export enum ChannelTaskMonitorTargetName {
  advertisement = '广告数', // 广告数
  recharge_times = '充值次数', // 充值次数
  recharge_amount = '充值金额', // 充值金额
  cost_amount = '消耗金额', // 消耗金额
}

// 系统监控周期
export enum ChannelTaskPeriodType {
  daily = 1, // 每日
  whole_scoped = 2, // 任务全周期
}

export enum ChannelTaskPeriodTypeName {
  daily = '每日', // 每日
  whole_scoped = '任务全周期', // 任务全周期
}

export interface TaskProgressInfo {
  core_task_process_detail: CoreTaskProgressDetail[]; // 核心指标进度详情
  monitor_completed_count: string; // 实际达标数
  monitor_operator: string; // 操作符
  monitor_target: ChannelTaskMonitorTarget;
  monitor_target_name: ChannelTaskMonitorTargetName;
  monitor_target_count: string; // 目标值
  period_type: ChannelTaskPeriodType; // 系统监控周期
  period_type_name: ChannelTaskPeriodTypeName; // 系统监控周期
}

export interface ChannelTaskCourseInfo {
  course_id: number; // 课程ID
  course_name: string; // 课程名称
  course_type: string; // 课程类型
  is_completed: boolean; // 是否完成本课程
}

// 是否允许备注
export enum StatusCommentReuirement {
  must = 1, // "必填"
  optional = 2, // "选填"
  must_not = 3, // "不填"
}

export interface SupportUpdateTaskStatusConfig {
  enable: boolean; // 是否支持
  commentReuirement: StatusCommentReuirement;
}

export interface CoreTaskProgressDetail {
  completed: number; // 达标数
  date: string; // 时间
  is_completed: boolean; // 是否达标
}

export enum TaskScope {
  team = 1,
  personal = 0,
};

export enum TaskAgencyType {
  public = 0,
  private = 1,
}

export enum TaskType {
  ongoing = 'ongoing',
  finished = 'finished',
}

export type TaskGroup = 'operate' | 'learn' | 'remind';
